import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { Link } from '@/js/libs/router';
import { Media } from '../../../../../theme/Media.js';
import { NotificationIndicator } from '../../../../Elements/NotificationIndicator/index.js';
import { usePuzzleNavigationContext } from '../../context.js';
import { usePathMatch } from '../../hooks/index.js';
import { CornerBadge } from '../CornerBadge.js';
import { TagContainer, Wrapper } from './styled.js';
const ItemSubLink = ({ title, exact, path, to, onClick, dataTestId, tag, ribbon, showIndicator }) => {
    const match = usePathMatch({ path: path ?? to, exact });
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const { collapseMainNav } = usePuzzleNavigationContext();
    const handleCloseMenu = useCallbackRef(() => {
        if (to && isMobile) {
            collapseMainNav();
        }
    });
    return (_jsxs(Wrapper, { $active: match, children: [ribbon && _jsx(CornerBadge, { variant: ribbon }), to && (_jsxs(Link, { to: to, onClick: handleCloseMenu, "data-testid": dataTestId, children: [_jsx("span", { children: title }), showIndicator && _jsx(NotificationIndicator, { warning: true }), tag && _jsx(TagContainer, { children: tag })] })), onClick && (_jsxs("span", { onClick: onClick, "data-testid": dataTestId, children: [_jsx("span", { children: title }), showIndicator && _jsx(NotificationIndicator, { warning: true }), tag && _jsx(TagContainer, { children: tag })] }))] }));
};
export default memo(ItemSubLink);
